import {Link, useMatch, useResolvedPath} from "react-router-dom";
import logoutIcon from "../../img/log-out.svg";
import "./navbar.css";
import {useContext, useEffect, useState} from "react";
import {APIContext} from "../Globals.tsx";
import {loadFromStorage} from "../api/LocalStorage.tsx";

export default function Navbar(){
    const {logout} = useContext(APIContext);
    const [box, setBox] = useState({});
    const [ego, setEgo] = useState({});
    const [BackendUrl, setBackendUrl] = useState({});
    const isSmallScreen = window.innerWidth < 1096;

    useEffect(() => {
        loadFromStorage("box").then((box) => {
            setBox(box);
        });
        loadFromStorage("ego").then((ego) => {
            setEgo(ego);
        });
        setBackendUrl(localStorage.getItem("backendUrl"))
    }, []);

    if(window.location.pathname === "/boxtv")
      return null

    return (
        <nav style={{height: "auto"}}>
            {isSmallScreen ? <div/> :
                <img className={"boxlogo none-mobile-tile"}
                     src={BackendUrl + box.photo} alt={"boxlogo"}/>}
            <h2 onClick={()=>window.location.replace("/")} style={{cursor: "pointer"}}>Hallo {ego.firstname} @ {box.name}</h2>
            <div/>
            <img className={"icon light"} src={logoutIcon} onClick={logout} alt={"logoutIcon"}/>
            <CustomLink onClick={()=>window.location.replace("/user")}>
                {!isSmallScreen && <img className={"user"}
                      src={BackendUrl + ego.photo} alt={"userlogo"}/>}
            </CustomLink>
        </nav>
    );
}

export function CustomLink({to, children, ...props}){
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({path: resolvedPath.pathname, end: true});
    // sodass nur exacter path gematched wird und nicht teil daovn
    return (
        <div className={isActive ? "active" : ""}>
            <Link to={to} {...props}>
                {children}
            </Link>
        </div>
    );
}